import Decimal from 'decimal.js-light';

export const safeDecimal = (value?: number): Decimal => new Decimal(value || 0);

export const getSumOfNumbers = (values: number[]) =>
  values.reduce((acc, val) => acc.plus(safeDecimal(val)), new Decimal(0)).toNumber();